import React from 'react'
import { Box, Tab, Tabs } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// 2026-10-20 결재 V2 이관: 기존 결재함(V1, index 라우트)은 그대로 두고 "결재함(V2)" 탭을
// 추가했다 - V1/V2 문서가 서로 다른 테이블(COM_APPR_DET vs COM_APPR_DOC_INF)에 있어 한
// 목록으로 합치지 않고 탭으로 분리했다(KSM도 결재 모니터링은 V1만 보여주는 것과 같은 제약).
const ApprovalMngPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const isV2 = location.pathname.endsWith('/v2');

    return (
        <Box>
            <Tabs
                value={isV2 ? 'v2' : 'v1'}
                onChange={(e, v) => navigate(v === 'v2' ? '/approvalmng/v2' : '/approvalmng')}
                sx={{ mb: 1 }}
            >
                <Tab value="v1" label="결재함" />
                <Tab value="v2" label="결재함(V2)" />
            </Tabs>
            <Outlet />
        </Box>
    )
}

export default ApprovalMngPage
